<!-- //NOSONAR --><li class="nav-item" [ngClass]="wrapperClass">
  <app-nav-item [item]="navItem" [count]="newsLength"></app-nav-item>
  <ng-container *ngIf="isLogin$ | async"> </ng-container>
</li>
